import {FlexRow, styled} from "@reside/ui";

export const Space = styled(FlexRow)`
  align-items: center;
  justify-content: normal;
  & > * ~ * {
    margin-left: ${({theme}) => theme.space[4]}px;
  }
`;
